export const dataPersonEntityId = {
  type: 'number',
};
